import SERVICE_URL from "../config/API_DATA"
import BaseConfiguration from "../config/base.js"
import HttpPost from "../http/httppost.js";
import Logger from './logger.js';

import {
    LOG_TYPE,
    FILE_NAME
} from "../config/API_DATA";
export default class CalculatePayment {
    static buildRequest(pSessionId,pPaymentSettingsId) {
        if (BaseConfiguration.isDebug) console.log("buildRequest");

        let returnValue = null;

        try {
           
            let body = {
                "sessionId":pSessionId,
                "paymentSettingsId":pPaymentSettingsId
            };

            returnValue = body;
        } catch (err) {
            let body = Logger.buildRequest(FILE_NAME.API_SELECT_PAYMENT_FOR_HOTEL, "error in building body for select payment api", err.toString(), "buildRequest", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        if (BaseConfiguration.isDebug) console.log("getResponse");

        let returnValue = null;
        try {

            returnValue = await HttpPost.makeHttpPostRequest(SERVICE_URL.API_SELECT_PAYMENT_FOR_HOTEL, pReqOptions);

        } catch (err) {

            let body = Logger.buildRequest(FILE_NAME.API_SELECT_PAYMENT_FOR_HOTEL, "error in getting Response from select payment api ", err.toString(), "getResponse", LOG_TYPE.ERROR);
            Logger.getResponse(body);
        }
        // console.log(returnValue);
        return returnValue;

    }


}